<div class="header">
    <h3>{{ caption }}</h3>
</div>
<div class="body">
    <ng-content></ng-content>
</div>
